import { Injectable } from '@angular/core';
import { StkmeServicePkg } from './stkmePkg.service';
import { jkLib, jkRestReturn } from 'jk-service';
import { AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class StkmeService extends StkmeServicePkg {

  constructor() {
    super();
    this.idNameOpt.sqlSelect= `SELECT ME001 as id,ME002 as name,ME001+'-'+ME002 as idName,ME002+'-'+ME001 as nameId,ME003 as ps1 FROM STKME `;
    this.idNameOpt.sqlWhere= `  `
    this.idNameOpt.sqlOrder= 'ORDER BY ME001';
    this.loadIdNameList(this.idNameOpt);

  }
  async importStkmj(date: string,ret:jkRestReturn): Promise<void> {
     // http://localhost:9086/stock/stkmeImportStkmj?date=20240903
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/stock/stkmeImportStkmj?date=${date}`,
      'get',
      '',
      undefined
    );

    let bool = await this.doAxios(config, ret);

  }

}

